import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { delay, Observable } from 'rxjs';
import { ArticlesData } from '../model/article.type';
import { Brand } from '../model/brand.type';
import { DashboardConfig } from '../model/dashboard.type';
import { Journey } from '../model/journey.type';
import { Planning } from '../model/planning.type';
import { TasksData } from '../model/tasks.type';
import { JobsWidget, JobSearchWidget } from '../model/jobs.type';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  http = inject(HttpClient);

  baseUrl = `${environment.url.api}/dashboard`;

  getConfig(): Observable<DashboardConfig> {
    return this.http.get<DashboardConfig>(`${this.baseUrl}/config`);
  }

  getBrand(): Observable<Brand> {
    return this.http.get<Brand>(`${this.baseUrl}/brand`);
  }

  getPlanning(): Observable<Planning> {
    return this.http.get<Planning>(`${this.baseUrl}/planning`);
  }

  getTasks(): Observable<TasksData> {
    return this.http.get<TasksData>(`${this.baseUrl}/tasks`);
  }

  getArticles(): Observable<ArticlesData> {
    return this.http.get<ArticlesData>(`${this.baseUrl}/article`);
  }

  getJourney(): Observable<Journey> {
    return this.http.get<Journey>(`${this.baseUrl}/journey`);
  }

  getJobSearchWidget(): Observable<JobSearchWidget> {
    return this.http.get<JobSearchWidget>(`${this.baseUrl}/searchjobs`);
  }

  getJobsWidget(): Observable<JobsWidget> {
    return this.http.get<JobsWidget>(`${this.baseUrl}/jobs`);
  }
}
